module.exports = __webpack_public_path__ + "static/media/Klevra_figure_old.05b64a0e.jpeg";